export default __webpack_public_path__ + "static/media/ennovate_3.cbadf5d9.jpg";